export const CLAUDE_PARTNERSHIP_POST_ID = "optra-labs-claude-partnership-announcement-2026";

export const PARTNERSHIP_LOGO_META = {
  [CLAUDE_PARTNERSHIP_POST_ID]: {
    partnerName: "Claude",
    logoSrc: "/anthropic-com-wordmark.png",
    logoAlt: "Anthropic Claude logo",
    logoClassName: "h-4 w-auto max-w-[136px]",
    partnerUrl: "https://claude.com/partners",
  },
  "optra-labs-airwallex-partnership-announcement-2026": {
    partnerName: "Airwallex",
    logoSrc: "/Airwallex-Logo.svg",
    logoAlt: "Airwallex logo",
    logoClassName: "h-5 w-auto max-w-[170px]",
    partnerUrl: "https://www.airwallex.com",
  },
  "optra-labs-hubspot-partnership-announcement-2026": {
    partnerName: "HubSpot",
    logoSrc: "/hubspot-seeklogo.svg",
    logoAlt: "HubSpot logo",
    logoClassName: "h-7 w-auto max-w-[200px]",
    partnerUrl: "https://www.hubspot.com/",
  },
  "optra-labs-osome-partnership-announcement-2026": {
    partnerName: "Osome",
    logoSrc: "/osome-logo.png",
    logoAlt: "Osome logo",
    logoClassName: "h-5 w-auto max-w-[170px]",
    partnerUrl: "https://osome.com/sg/",
  },
  "optra-labs-xero-partnership-announcement-2026": {
    partnerName: "Xero",
    logoSrc: "/xero.svg",
    logoAlt: "Xero logo",
    logoClassName: "h-6 w-auto max-w-[190px]",
    partnerUrl: "https://www.xero.com/",
  },
};

export const PARTNERSHIP_POST_IDS = Object.keys(PARTNERSHIP_LOGO_META);

export const TRUST_BAR_PARTNERS = [
  {
    name: "Claude Partner Network",
    logoSrc: "/anthropic-com-wordmark.png",
    logoAlt: "Anthropic Claude logo",
    logoClassName: "block h-4 sm:h-4 md:h-5 w-auto",
    url: "https://claude.com/partners",
    ariaLabel: "Visit the Claude Partner Network",
  },
  {
    name: "Airwallex",
    logoSrc: "/Airwallex-Logo.svg",
    logoAlt: "Airwallex",
    logoClassName: "block h-5 sm:h-5 md:h-6 w-auto",
    url: "https://www.airwallex.com",
    ariaLabel: "Visit Airwallex",
  },
  {
    name: "HubSpot",
    logoSrc: "/hubspot-seeklogo.svg",
    logoAlt: "HubSpot",
    logoClassName: "block h-5 sm:h-5 md:h-[1.95rem] w-auto",
    url: "https://www.hubspot.com/",
    ariaLabel: "Visit HubSpot",
  },
  {
    name: "Osome",
    logoSrc: "/osome-logo.png",
    logoAlt: "Osome",
    logoClassName: "block h-5 sm:h-5 md:h-6 w-auto",
    url: "https://osome.com/sg/",
    ariaLabel: "Visit Osome Singapore",
  },
  {
    name: "Xero",
    logoSrc: "/Xero%20Wordmark_Blue.png",
    logoAlt: "Xero",
    logoClassName: "block h-5 sm:h-5 md:h-6 w-auto",
    url: "https://www.xero.com/",
    ariaLabel: "Visit Xero",
  },
];

export function isPartnershipPost(postId) {
  return PARTNERSHIP_POST_IDS.includes(String(postId || ""));
}

export function getPartnershipLogoMeta(postId) {
  return PARTNERSHIP_LOGO_META[String(postId || "")] || null;
}
